import * as React from 'react';

const SvgAssessment = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.2}
      d="M3 18L3 6C3 3.79086 4.79086 2 7 2L14 2L21 9L21 18C21 20.2091 19.2091 22 17 22L7 22C4.79086 22 3 20.2091 3 18Z"
      fill="#605AFB"
    />
    <path d="M14 5L14 2L21 9L18 9C15.7909 9 14 7.20914 14 5Z" fill="#605AFB" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4939 11.4356C15.8056 11.7083 15.8372 12.1822 15.5645 12.4939L12.6946 15.7738C12.0779 16.4786 11.0156 16.5729 10.2843 15.9879L8.53151 14.5857C8.20806 14.3269 8.15562 13.8549 8.41438 13.5315C8.67313 13.208 9.1451 13.1556 9.46855 13.4144L11.2214 14.8166C11.3258 14.9002 11.4776 14.8867 11.5657 14.786L14.4356 11.5061C14.7084 11.1944 15.1822 11.1628 15.4939 11.4356Z"
      fill="#605AFB"
    />
  </svg>
);

export default SvgAssessment;
